/*
 * @Author: 1544807500@qq.com
 * @Date: 2025-06-03 10:19
 * @LastEditors: yinping.che@ginlong.com
 * @LastEditTime: 2025-08-15 16:45
 * @FilePath: \solis_storage_cloud_web\src\stores\system.js
 * @Description: xxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
 */
import { defineStore } from 'pinia';
import { merge, set } from 'lodash-es';
import { updateIco, updateTheme, updateLang } from '@/utils/changeSystem/index.js'
import { cloneDeep } from 'lodash-es'
export const useSystemConfigStore = defineStore('systemConfig', {
  state: () => ({
    config: {// 配置
      odmConfig: {// odm配置
        infoLogo: "",// 左侧菜单顶部logo
        iconLogo: "",// 网站标签页ico
        helpLink: "",// 帮助文档链接
      },
    },
    isDark: false, // 是否是暗黑模式
    awaitUpgradesCount: 0,// 待升级设备数
    language: '1',// 语言
    defaultConfig: {
      odmConfig: {// odm配置
        infoLogo: "",// 左侧菜单顶部logo
        iconLogo: "",// 网站标签页ico
        helpLink: "",// 帮助文档链接
      },
    },
    isCollapseMenu: false,// 是否是折叠状态菜单
  }),
  // 启用持久化
  persist: {
    enabled: true,
    strategies: [
      {
        key: 'systemConfig',
        storage: localStorage,
        paths: ['config'], // 指定需要持久化的字段
      },
    ],
  },
  getters: {
    // 根据待升级设备数判断头像是否显示红点
    // 若待升级设备数不为 0，则返回 true，否则返回 false
    avatarRedDot: (state) => !!state.awaitUpgradesCount
  },
  actions: {
    // 保存系统配置
    setSystemConfig(config) {
      this.config = cloneDeep(config)
      this.defaultConfig = cloneDeep(config)
      // 持久化存储（可选）
      localStorage.setItem("systemConfig", JSON.stringify(config))
    },
    // 更新系统配置
    updateSystemConfig(newConfig) {
      console.log("🚀 ~ updateSystemConfig ~ newConfig:", newConfig)
      this.config = merge(this.config, newConfig)
      // 修改标签页ico
      if(newConfig?.odmConfig?.iconLogo){
        updateIco(newConfig?.odmConfig?.iconLogo)
      }
      // 修改主题色
      if(newConfig?.odmConfig?.themeColor){
        updateTheme(newConfig?.odmConfig?.themeColor)
      }
    },
    async updateLang(language){
     await updateLang(language)
      this.language = language
    },
    // 设备待升级数量
    setAwaitUpgradesCount(value) {
      this.awaitUpgradesCount = value
    },
    updateCollapseMenu(value){
      this.isCollapseMenu = value
    }
  },
});
